import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { VoteStatus } from "types/voteEnum";

import ActionSectionLayout from "components/vote/common/ActionSectionLayout";

import ValidateButton from "./Buttons/ValidateButton";

// Space kept for the message of the statuses without one
const EMPTY_MESSAGE_HEIGHT = "16px";

type Props = {
    voteStatus: VoteStatus;
    handleValidate: () => void;
    handleReset?: () => void;
    canAnswerBeUpdated: boolean;
};

const ActionSection = ({
    voteStatus,
    handleValidate,
    handleReset,
    canAnswerBeUpdated,
}: Props) => {
    const { t } = useTranslation();

    function renderMessage() {
        switch (voteStatus) {
            case VoteStatus.PendingValidation:
                return <p>{t("answerNotValidated.quizzbox")}</p>;
            case VoteStatus.Success:
                return <p>{t("sentSucceded.quizzbox")}</p>;
            case VoteStatus.Loading:
                return <p>{t("loading")}</p>;
            case VoteStatus.Error:
                return <p>{t("errorUnknown")}</p>;
            default:
                return <EmptyMessage />;
        }
    }

    function handleClick() {
        if (handleReset && VoteStatus.Success === voteStatus) {
            handleReset();
            return;
        }
        handleValidate();
    }

    const isSuccess = VoteStatus.Success === voteStatus;
    const isIdle = VoteStatus.Idle === voteStatus;
    const shouldDisplayButton = !isSuccess || canAnswerBeUpdated;
    const buttonText = isSuccess ? (
        <span>{t("changeAnswer.quizzbox")}</span>
    ) : (
        <span>{t("validateAnswer.quizzbox")}</span>
    );
    const buttonColor = isSuccess ? "#808080" : "#60b860";
    const isButtonDisabled = isIdle || VoteStatus.Loading === voteStatus;
    const messageColor = isSuccess ? "green" : "red";
    const button = shouldDisplayButton ? (
        <ValidateButton
            color={buttonColor}
            isDisabled={isButtonDisabled}
            onClick={handleClick}
            text={buttonText}
        />
    ) : null;

    return (
        <ActionSectionLayout
            button={button}
            isAlertMessage={VoteStatus.Error === voteStatus}
            isIdle={isIdle}
            message={renderMessage()}
            messageColor={messageColor}
        />
    );
};

const EmptyMessage = styled.p`
    height: ${EMPTY_MESSAGE_HEIGHT};
`;

export default ActionSection;
